import { Component } from '@angular/core';

@Component({
  selector: 'app-administrator-dashboard',
  templateUrl: './administrator-dashboard.component.html',
  styleUrl: './administrator-dashboard.component.scss'
})
export class AdministratorDashboardComponent {}
